import {factory} from './localStorage'

export const USER = factory(process.env.VUE_APP_USER_TYPE)
